import { render, staticRenderFns } from "./SABWidgetGenerator.vue?vue&type=template&id=5976df47&scoped=true"
import script from "./SABWidgetGenerator.vue?vue&type=script&lang=js"
export * from "./SABWidgetGenerator.vue?vue&type=script&lang=js"
import style0 from "./SABWidgetGenerator.vue?vue&type=style&index=0&id=5976df47&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5976df47",
  null
  
)

export default component.exports